import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const MATHALON_ROUTE = {
  name: 'mathalon',
  route(classId: string): string[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
  },

  DEFAULT: '',

  WINNERS: {
    name: 'winners/:mathalonType',
    route(classId: string, mathalonType: string): string[] {
      return [...MATHALON_ROUTE.route(classId), 'winners', mathalonType];
    },
  }
};